"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Users = exports.UserTypes = void 0;
var headers_1 = require("../../shared/headers");
var client_1 = require("../../shared/http/client");
exports.UserTypes = __importStar(require("./types"));
var Users = /** @class */ (function () {
    function Users(apiUrl, appDetails, apiSecurity) {
        this.client = client_1.HttpClient.create(apiUrl, apiSecurity.unauthorizedCallback);
        this.appDetails = appDetails;
        this.apiSecurity = apiSecurity;
    }
    Users.client = function (apiUrl, appDetails, apiSecurity) {
        return new Users(apiUrl, appDetails, apiSecurity);
    };
    /**
     * Sends an invitation to the specified email
     * @param email
     */
    Users.prototype.sendInvitation = function (email) {
        return this.client.post('/user/invite', {
            email: email,
        }, this.headers());
    };
    /**
     * Initialize basic state of user and returns data after registration process
     * @param email
     * @param mnemonic
     */
    Users.prototype.initialize = function (email, mnemonic) {
        return this.client
            .post('/initialize', {
            email: email,
            mnemonic: mnemonic,
        }, this.headers())
            .then(function (data) {
            return data.user;
        });
    };
    /**
     * Returns fresh data of the user
     */
    Users.prototype.refreshUser = function () {
        return this.client.get('/user/refresh', this.headers());
    };
    /**
     * Updates the authentication credentials
     * @param payload
     */
    Users.prototype.changePassword = function (payload) {
        return this.client.patch('/user/password', {
            currentPassword: payload.currentEncryptedPassword,
            newPassword: payload.newEncryptedPassword,
            newSalt: payload.newEncryptedSalt,
            mnemonic: payload.encryptedMnemonic,
            privateKey: payload.encryptedPrivateKey,
        }, this.headers());
    };
    /**
     * Updates a user profile
     * @param payload
     */
    Users.prototype.updateProfile = function (payload) {
        return this.client.patch('/user/profile', payload, this.headers());
    };
    /**
     * Updates a user avatar
     * @param payload
     */
    Users.prototype.updateAvatar = function (payload) {
        var formData = new FormData();
        formData.set('avatar', payload.avatar);
        return this.client.put('/user/avatar', formData, this.headers());
    };
    /**
     * Delete current user avatar
     */
    Users.prototype.deleteAvatar = function () {
        return this.client.delete('/user/avatar', this.headers());
    };
    /**
     * Gets all friend invites created by this user
     */
    Users.prototype.getFriendInvites = function () {
        return this.client.get('/user/invite', this.headers());
    };
    /**
     * Sends verification email
     */
    Users.prototype.sendVerificationEmail = function () {
        return this.client.post('/user/sendVerificationEmail', {}, this.headers());
    };
    /**
     * Verifies user email
     */
    Users.prototype.verifyEmail = function (payload) {
        return this.client.post('/user/verifyEmail', payload, this.headers());
    };
    Users.prototype.headers = function () {
        return (0, headers_1.headersWithTokenAndMnemonic)(this.appDetails.clientName, this.appDetails.clientVersion, this.apiSecurity.token, this.apiSecurity.mnemonic);
    };
    return Users;
}());
exports.Users = Users;
